import React from 'react';
// import '../../../../styles/site.css';
import '../../../styles/site.css';
import Session from '../session';
import APP from '../../tools/AppRoutes';

const Header = (props) => {
    const acceso = JSON.parse(localStorage.getItem('user'));

    return (
        <>
            {acceso !== null && acceso.Login !== "" ? (
                <nav className="navbar navbar-expand-lg navbar-light" style={{ padding: 0 }} id="navbar-master">
                    {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}
                    <div className='col-md-2 divBotonMaestroFFEE' >
                        <a className="linkFFEE botonMaestroFFEE" href={APP.HOME} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>HOME</a>
                    </div>
                    <div className='col-md-10'>
                        <Session></Session>
                    </div>
                </nav>)
                : (<nav className="navbar-master" id="navbar-master">
                    <div className='col-md-2'>
                        {/* <a className="linkFFEE" target="blank" href={APP.HOME}>HOME</a> */}
                    </div>
                    <div className='col-md-10'>
                        {/* <Session></Session> */}
                    </div>
                </nav>)}
        </>
    )
}

export default React.memo(Header);